import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "color"];
import React from 'react';
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25 10.932A9.93 9.93 0 0 0 15.068 1v9.922H25v.01z"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.998 14.192c-.106 6.074-5.116 10.912-11.19 10.806-6.074-.106-10.912-5.116-10.806-11.19.106-6.074 5.116-10.912 11.19-10.806"
});
var Report = function Report(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: "26",
    height: "26",
    viewBox: "0 0 26 26"
  }, rest), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2.021"
  }, _ref2, _ref3));
};
export default Report;